// @ts-nocheck
/** *****
 * Store Custom Code:
 * For updates, compare with: modules\content-library\src\Components\ProductDescription.tsx
 * ****** */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useState } from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { dispatchProductClickEvent } from "@store/Services/AnalyticsService";
import { linkStyles } from "@store/Themes/common/mixins/link";
/* Store Custom Code - End */

interface OwnProps {
    product: CartLineModel | ProductContextModel | OrderLineModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductDescriptionStyles;
    analyticsId?: string; // Store Custom Code
}

type Props = OwnProps;

export interface ProductDescriptionStyles {
    productDetailLink?: LinkPresentationProps;
    productDetailDescription?: TypographyProps;
}

export const productDescriptionStyles: ProductDescriptionStyles = {
    productDetailLink: {
        css: css`
            width: 100%;
        `,
        typographyProps: {
            /* Store Custom Code - Start */
            css: css`
                ${wrapInContainerStyles}
                ${linkStyles("primary", "primary", false, true)}
                width: 100%;
                color: ${getColor("primary")};
                font-size: ${x => x.theme.design.typography.size.large};
                font-weight: ${x => x.theme.design.typography.weight.medium};
                line-height: ${x => x.theme.design.typography.lineHeight.small};
            `,
            /* Store Custom Code - End */
        },
    },
};

const ProductDescription = ({ product, onClick, extendedStyles, analyticsId /* Store Custom Code */ }: Props) => {
    const [styles] = useState(() => mergeToNew(productDescriptionStyles, extendedStyles));

    const description =
        "product" in product
            ? product.product.productTitle
            : product.shortDescription || ("description" in product ? product.description : "");
    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;

    /* Store Custom Code - Start */
    const handleAnalyticsClick = () => {
        dispatchProductClickEvent(product, analyticsId);
    };
    /* Store Custom Code - End */

    return productDetailPath && (!("isActiveProduct" in product) || product.isActiveProduct) ? (
        /* Store Custom Code - next line wrapper with Typography */
        <Typography as="h2">
            <Link
                {...styles.productDetailLink}
                href={productDetailPath}
                alt={`See product details for ${description}`}
                onClick={handleAnalyticsClick} // Store Custom Code
                data-test-selector="productDescriptionLink"
            >
                {description}
            </Link>
        </Typography>
    ) : (
        <Typography {...styles.productDetailDescription}>{description}</Typography>
    );
};

export default ProductDescription;
